import React from 'react'
import { logger } from '@utils/Logger'
// import { FeatureFlagGuard } from '@components/guards'
// import { FEATURE_FLAGS } from '@constants'
import { DevUiPanel } from './DevUiPanel'

/**
 * DevUI Wrapper Component
 * Wraps the DevUI Panel with feature flag protection
 */
export const DevUIWrapper: React.FC = () => {
  // Debug logging to help identify issues
  // logger.debug('[DevUIWrapper] Rendering DevUIWrapper component')

  // TODO: Uncomment this when we add the Feature Flag Guard
  // return (
  //   <FeatureFlagGuard
  //     featureFlag={FEATURE_FLAGS.DEV_UI_PANEL}
  //     fallbackPath={window.location.pathname + window.location.search}>
  //     <DevUiPanel />
  //   </FeatureFlagGuard>
  // )

  return <DevUiPanel />
}

export default DevUIWrapper
